export default { sha: '75e3306f41c90a6aab1231556325ad686a02bb82', buildNumber: 'undefined' }
